import * as React from 'react';
import { IDefaultProps } from './IDefaultProps';
import { MessageBar } from 'office-ui-fabric-react';

export default class Default extends React.Component<IDefaultProps, {}>{


    public render() {
        return (
            <MessageBar>
                <h2>{this.props.message}</h2>
            </MessageBar>
        );
    }
}



// WEBPACK FOOTER //
// ../../../../../src/webparts/bannerWp/components/Default/Default.tsx